import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "../StatusCard";
import { MetricCard } from "../MetricCard";
import { HealthBadge } from "../HealthBadge";
import { QueryStateBoundary } from "../QueryStateBoundary";
import { useReadiness, useLiveness } from "@/hooks/queries/useHealthStatus";

interface ReadinessPayload {
  status: string;
  service_registry?: { registered_service_count: number } | null;
  lifecycle?: {
    total_components: number;
    ready_components: number;
    error_components: number;
  } | null;
}

interface LivenessPayload {
  status: string;
}

export function PlatformHealthSection(): React.JSX.Element {
  const readinessQuery = useReadiness();
  const livenessQuery = useLiveness();

  return (
    <StatusCard title="Platform Health">
      <Stack spacing={1.5}>
        <QueryStateBoundary query={readinessQuery}>
          {(payload) => {
            const readiness = payload as unknown as ReadinessPayload;
            const lifecycle = readiness.lifecycle;
            const diagnosticsSummary = lifecycle
              ? `${lifecycle.ready_components}/${lifecycle.total_components} components ready, ${lifecycle.error_components} in error`
              : null;
            return (
              <>
                <MetricCard
                  label="Overall Health"
                  render={<HealthBadge status={readiness.status} />}
                />
                <MetricCard label="Readiness" render={<HealthBadge status={readiness.status} />} />
                <MetricCard label="Diagnostics Summary" value={diagnosticsSummary} />
              </>
            );
          }}
        </QueryStateBoundary>
        <QueryStateBoundary query={livenessQuery}>
          {(payload) => {
            const status = (payload as unknown as LivenessPayload).status;
            return <MetricCard label="Liveness" render={<HealthBadge status={status} />} />;
          }}
        </QueryStateBoundary>
      </Stack>
    </StatusCard>
  );
}
